import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import AdminWorkflowBootstrap from './components/AdminWorkflowBootstrap'
import AdminFlowParityV3 from './components/AdminFlowParityV3'
import AdminCommerceParityEnhancer from './components/AdminCommerceParityEnhancer'
import AdminFieldStructureParityEnhancer from './components/AdminFieldStructureParityEnhancer'
import AdminServiceScopeFieldParityEnhancer from './components/AdminServiceScopeFieldParityEnhancer'
import './styles.css'
import './admin-readability.css'
import './admin-controls.css'
import './service-catalog.css'
import './admin-governance.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
    <AdminWorkflowBootstrap />
    <AdminFlowParityV3 />
    <AdminCommerceParityEnhancer />
    <AdminFieldStructureParityEnhancer />
    <AdminServiceScopeFieldParityEnhancer />
  </React.StrictMode>,
)
